var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 22.6665L16 17.8665L20.8 22.6665L22.6666 20.7998L17.8666 15.9998L22.6666 11.1998L20.8 9.33317L16 14.1332L11.2 9.33317L9.33329 11.1998L14.1333 15.9998L9.33329 20.7998L11.2 22.6665ZM16 29.3332C14.1555 29.3332 12.4222 28.9832 10.8 28.2832C9.17774 27.5832 7.76663 26.6332 6.56663 25.4332C5.36663 24.2332 4.41663 22.8221 3.71663 21.1998C3.01663 19.5776 2.66663 17.8443 2.66663 15.9998C2.66663 14.1554 3.01663 12.4221 3.71663 10.7998C4.41663 9.17761 5.36663 7.7665 6.56663 6.5665C7.76663 5.3665 9.17774 4.4165 10.8 3.7165C12.4222 3.0165 14.1555 2.6665 16 2.6665C17.8444 2.6665 19.5777 3.0165 21.2 3.7165C22.8222 4.4165 24.2333 5.3665 25.4333 6.5665C26.6333 7.7665 27.5833 9.17761 28.2833 10.7998C28.9833 12.4221 29.3333 14.1554 29.3333 15.9998C29.3333 17.8443 28.9833 19.5776 28.2833 21.1998C27.5833 22.8221 26.6333 24.2332 25.4333 25.4332C24.2333 26.6332 22.8222 27.5832 21.2 28.2832C19.5777 28.9832 17.8444 29.3332 16 29.3332ZM16 26.6665C18.9777 26.6665 21.5 25.6332 23.5666 23.5665C25.6333 21.4998 26.6666 18.9776 26.6666 15.9998C26.6666 13.0221 25.6333 10.4998 23.5666 8.43317C21.5 6.3665 18.9777 5.33317 16 5.33317C13.0222 5.33317 10.5 6.3665 8.43329 8.43317C6.36663 10.4998 5.33329 13.0221 5.33329 15.9998C5.33329 18.9776 6.36663 21.4998 8.43329 23.5665C10.5 25.6332 13.0222 26.6665 16 26.6665Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellation);
export default __webpack_public_path__ + "static/media/Cancellation.4308891371bcb4cfb6d9ac796235a90d.svg";
export { ForwardRef as ReactComponent };